import request from '@/utils/request'

export function addCodeSubmit(data) {
  return request({
    url: '/gesp-code-submits',
    method: 'post',
    data
  })
}

export function getCodeSubmitPage(params) {
  return request({
    url: '/gesp-code-submits/page',
    method: 'get',
    params
  })
}

export function getLatestSubmit(userId, quesId) {
  return request({
    url: '/gesp-code-submits/latest',
    method: 'get',
    params: { userId, quesId }
  })
}

export function getLatestSubmitBatch(userId, quesIds) {
  return request({
    url: '/gesp-code-submits/latest/batch',
    method: 'post',
    data: { userId, quesIds }
  })
}
